export const types = {
  SET_FILTERS: 'SET_FILTERS',
  SET_OVERVIEW: 'SET_OVERVIEW',
  SET_FUNNEL: 'SET_FUNNEL',
  SET_RANKINGS: 'SET_RANKINGS',
  SET_DISTRIBUTION: 'SET_DISTRIBUTION',
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_SYNC_STATUS: 'SET_SYNC_STATUS',
  BUMP_REQUEST_ID: 'BUMP_REQUEST_ID',
};

export default {
  [types.SET_FILTERS](state, filters) {
    state.filters = { ...state.filters, ...filters };
  },
  [types.SET_OVERVIEW](state, data) {
    state.overview = data;
  },
  [types.SET_FUNNEL](state, data) {
    state.funnel = data;
  },
  [types.SET_RANKINGS](state, data) {
    state.rankings = data;
  },
  [types.SET_DISTRIBUTION](state, data) {
    state.distribution = data;
  },
  [types.SET_UI_FLAG](state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
  [types.SET_SYNC_STATUS](state, status) {
    state.syncStatus = { ...state.syncStatus, ...status };
  },
  [types.BUMP_REQUEST_ID](state, key) {
    state.requestIds = {
      ...state.requestIds,
      [key]: state.requestIds[key] + 1,
    };
  },
};
